export default __webpack_public_path__ + "static/media/CEOslurp.b897264f.jpg";